import { Helmet } from 'react-helmet-async';
import SEO from '../components/SEO';

const About = () => {
  return (
    <>
      <SEO 
        title="About Us | JM Rehab Clinic Surrey - Our Team & History"
        description="Founded in 2021, JM Rehab Clinic features experienced therapists Wren Paul Meyn and Jisha Jacob. Discover our mission of providing personalized, evidence-based physiotherapy and massage therapy in Surrey, BC."
        keywords="Wren Paul Meyn physiotherapist, Jisha Jacob RMT, Surrey physiotherapy clinic, massage therapy Surrey, clinic history, about JM Rehab"
        pathname="/about"
      />

      <div className="pt-24 pb-12 bg-gray-50">
        {/* Vision and History Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-8">About Us</h1>
          
          <div className="bg-white rounded-lg shadow-md p-8 mb-12">
            <div className="md:flex gap-8">
              <div className="md:w-1/2">
                <h2 className="text-2xl font-semibold mb-6">Our Vision & History</h2>
                <div className="prose max-w-none space-y-4">
                  <p>
                    At our physiotherapy/Registered massage therapy clinic, we envision a world where everyone has access to optimal health and wellness. Our goal is to empower individuals to achieve their fullest potential through personalized, evidence-based care.
                  </p>
                  <p>
                    We aim to inspire our patients to take an active role in their healing journey, recovery and overall well-being, helping them lead healthier, more active lives. Through innovation, compassion, encouragement and collaboration, we aspire to transform the lives of those we serve, making a positive impact in our community and beyond.
                  </p>
                  <p>
                    Established in 2021, JM Rehab Clinic began when two therapists recognized the need for high-quality, accessible physiotherapy and massage therapy services in our community. We started small but very dedicated, focusing on building strong relationships with our patients and emphasizing evidence-based practices.
                  </p>
                  <p>
                    Today, we are proud to offer a comprehensive range of therapies and rehab programs, continuing to uphold our core values of compassion, empowerment, and community engagement. Our clinic has become a trusted resource for many, and we remain dedicated to our mission of helping each patient achieve their health and rehabilitative goals.
                  </p>
                </div>
              </div>
              <div className="md:w-1/2 h-full">
                <img 
                  src="/images/vision.jpg" 
                  alt="JM Rehab Clinic Front View" 
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Meet the Team Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12">Meet the Team</h2>
          
          {/* Wren Paul Meyn Section */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden mb-12">
            <div className="md:flex">
              <div className="p-6 md:w-2/3">
                <h3 className="text-2xl font-semibold mb-2">Wren Paul Meyn</h3>
                <p className="text-sage-green font-medium mb-4">Physiotherapist</p>
                <div className="prose max-w-none space-y-4">
                  <p>
                    Practicing in British Columbia, Canada since the year. Prior to being a registrant in Canada, I served in the Ministry of Health sultanate of Oman for 10 years.
                  </p>
                  <p>
                    My practice is evidence based and grounded in the latest research and clinical guidelines. Every effort is taken to stay informed about advancements in the field to provide the most effective and innovative care.
                  </p>
                  <div>
                    <h4 className="text-lg font-semibold mb-2">Services Provided:</h4>
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Physiotherapy Assessment and Treatment</li>
                      <li>IMS/Dry Needling</li>
                      <li>Physio-assisted Active Rehab</li>
                      <li>Vestibular & Concussion Therapy</li>
                      <li>Shoulder Assessment and Treatment</li>
                      <li>Neuro Rehab</li>
                      <li>Post Surgery Rehab</li>
                      <li>Manual Therapy and Exercise Prescription</li>
                    </ul>
                  </div>
                  <p className="italic">
                    "Apart from practicing the profession, I love to travel with my family, exploring beautiful British Columbia, meeting people, learning about the indigenous cultures in BC, collecting indigenous arts, listening to music, attending rock concerts, experimenting with sound systems, wood crafts and gardening both indoors and outdoors."
                  </p>
                </div>
              </div>
              <div className="md:w-1/3 h-full">
                <img 
                  src="/images/wren.jpg" 
                  alt="Wren Paul Meyn" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Jisha Jacob Section */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="md:flex">
              <div className="md:w-1/3 h-full">
                <img 
                  src="/images/jisha.jpg" 
                  alt="Jisha Jacob" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 md:w-2/3">
                <h3 className="text-2xl font-semibold mb-2">Jisha Jacob</h3>
                <p className="text-sage-green font-medium mb-4">Registered Massage Therapist</p>
                <div className="prose max-w-none space-y-4">
                  <p>
                    College registrant since the year 2020. Graduated from Dr. MGR Medical University with a Bachelor degree in Physiotherapy from India, shared my knowledge with physiotherapy college students while briefly working as lecturer in two different institutions.
                  </p>
                  <p>
                    Prior to immigrating to Canada, I worked in a multispeciality hospital in the Middle East for nearly 10 years as a senior Physiotherapist.
                  </p>
                  <div>
                    <h4 className="text-lg font-semibold mb-2">Services Provided:</h4>
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Therapeutic Massage</li>
                      <li>Hot/Cold Stone Massage</li>
                      <li>Myo-fascial Release</li>
                      <li>Trigger Point Treatment</li>
                    </ul>
                  </div>
                  <p className="italic">
                    "Proud mother of two awesome boys and a lovely cat named Freddie Mercury. I love to spend time at home with a cuppa tea, enjoy cooking and indoor aesthetic and classic literature. Any time yes to road trips, backpacking and hiking."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About; 